import React from 'react';
import icon from "../../assets/icons/tgIcon.svg";

export default () => (<img width={20} src={icon}/>);